export function ceilToDecimal(value: number) {
    return Math.ceil(value * 10) / 10
}
